<div class="file-upload-modal">
  <!-- File picker -->
  <label class="upload-dropzone" [class.disabled]="uploading">
    <input
      type="file"
      [accept]="data?.accept || '*'"
      [multiple]="data?.multiple !== false"
      [disabled]="uploading"
      (change)="onSelect($event)"
    />
    <i class="pi pi-upload"></i>
    <span class="text-900 font-medium">Click to choose file{{ data?.multiple !== false ? 's' : '' }}</span>
    <span class="text-600 text-sm">Max {{ maxSizeLabel }} per file</span>
  </label>

  <!-- Queue -->
  <ul class="file-queue" *ngIf="queue.length">
    <li *ngFor="let f of queue; let i = index" class="file-row" [class.has-error]="f.error">
      <i class="pi" [ngClass]="f.type?.startsWith('image/') ? 'pi-image' : 'pi-file'"></i>
      <div class="file-meta">
        <span class="file-name">{{ f.name }}</span>
        <small *ngIf="f.error" class="file-error">{{ f.error }}</small>
        <p-progressBar
          *ngIf="uploading && !f.error"
          [value]="f.percent"
          [showValue]="true"
          styleClass="upload-progress"
        ></p-progressBar>
      </div>
      <button
        *ngIf="!uploading"
        pButton
        type="button"
        icon="pi pi-times"
        class="p-button-text p-button-rounded p-button-sm"
        (click)="removeAt(i)"
      ></button>
    </li>
  </ul>

  <!-- Actions -->
  <div class="upload-actions">
    <button
      pButton
      type="button"
      label="Cancel"
      class="p-button-text"
      [disabled]="uploading"
      (click)="cancel()"
    ></button>
    <button
      pButton
      type="button"
      [label]="uploading ? 'Uploading…' : 'Upload'"
      icon="pi pi-upload"
      [disabled]="!canUpload"
      [loading]="uploading"
      (click)="upload()"
    ></button>
  </div>
</div>
